export const eventCategories = [
    {
        "id": -1,
        "name": "Alle",
        "uniqueName": ""
    },
    {
        "id": 247,
        "name": "Crossduathlon",
        "uniqueName": "CrossDuathlonEvents"
    },
    {
        "id": 248,
        "name": "Duathlon",
        "uniqueName": "DuathlonEvents"
    },
    {
        "id": 249,
        "name": "Inliner",
        "uniqueName": "InlineEvents"
    },
    {
        "id": 250,
        "name": "Laufen",
        "uniqueName": "RunEvents"
    },
    {
        "id": 251,
        "name": "Mountainbike",
        "uniqueName": "MtbEvents"
    },
    {
        "id": 252,
        "name": "Rennrad",
        "uniqueName": "RoadBikeEvents"
    },
    {
        "id": 253,
        "name": "Schwimmen",
        "uniqueName": "SwimEvents"
    },
    {
        "id": 254,
        "name": "Triathlon",
        "uniqueName": "TriEvents"
    },
    {
        "id": 285,
        "name": "Skilanglauf",
        "uniqueName": "SkiLanglaufEvents"
    },
    {
        "id": 345,
        "name": "Wandern / Walking",
        "uniqueName": "WalkingEvents"
    },
    {
        "id": 348,
        "name": "Crosslauf",
        "uniqueName": "CrossRunEvents"
    },
    {
        "id": 351,
        "name": "Hindernislauf",
        "uniqueName": "HindernisRunEvents"
    },
    {
        "id": 354,
        "name": "Frauenlauf",
        "uniqueName": "FrauenRunEvents"
    },
    {
        "id": 357,
        "name": "Rollstuhl",
        "uniqueName": "RollstuhlEvents"
    }
]


// WEBPACK FOOTER //
// /src/assets/data/categories/categories.ts